import React from 'react';
import { Cell } from 'fixed-data-table';
import { SortTypes } from '../Constants';

function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}

class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);

    this.handleSortChange = this.handleSortChange.bind(this);
  }

  render() {
    // specify "onSortChang" in this statement so that it won't be included in "rest" variable
    // to silence this warning: "warning.js?8a56:36Warning: Unknown prop `onSortChange` on <div> tag."
    // See: https://fb.me/react-unknown-prop
    let { sortDir, children, onSortChange, ...rest } = this.props;
    let style = { cursor: 'pointer' };
    style = { ...this.props.style, ...style };
    return (
      <Cell {...rest} style={style} onClick={this.handleSortChange}>
        {children} {sortDir ? (sortDir === SortTypes.DESC ? '↓' : '↑') : ''}
      </Cell>
    );
  }

  handleSortChange(e) {
    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}

export default SortHeaderCell;



// WEBPACK FOOTER //
// ./src/components/SortHeaderCell.js